// src/plugins/leads/services/leads.js

import api from 'api/axios';

const BASE_URL = 'api/leads';

/**
 * Ottiene la lista dei leads
 */
export const getLeads = (params = {}) => {
  return api.get(`${BASE_URL}/leads/`, { params });
};

/**
 * Ottiene un lead specifico per ID
 */
export const getLead = (id) => {
  return api.get(`${BASE_URL}/leads/${id}/`);
};

/**
 * Crea un nuovo lead
 */
export const createLead = (data) => {
  return api.post(`${BASE_URL}/leads/`, data);
};

/**
 * Aggiorna parzialmente un lead (PATCH)
 */
export const updateLead = (id, data) => {
  return api.patch(`${BASE_URL}/leads/${id}/`, data);
};

/**
 * Elimina un lead
 */
export const deleteLead = (id) => {
  return api.delete(`${BASE_URL}/leads/${id}/`);
};
